import { Injectable } from '@angular/core';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { AppointmentRequestModel } from '../business-entities/appointmentList-model';
import { ServiceAdvisorDataService } from '../data-services/service-advisor-data.service';


@Injectable({
  providedIn: 'root'
})
export class ServiceAdvisorService {

  constructor(
    private serviceAdvisorDataService: ServiceAdvisorDataService
  ) { }

  getServiceAdvisorDetails(appointmentRequestModel: AppointmentRequestModel): Promise<GenericResponse<any>> {
    return this.serviceAdvisorDataService.getServiceAdvisorDetails(appointmentRequestModel);
}

}
